// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel_Panel__1rFl7"};